import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { edit_card, delete_card, no_items } from '../../Image/Index';
import {
	getMerchantWallet,
	giftCardOrder,
	redeemMerchantWallet,
	refundMerchantWallet,
	createGiftCard,
	sendEmail,
	Token_Generator,
	removeCartItem,
	getCartDetails,
	saveOrder,
	updateOrder,
} from '../../actions/auth';
import { getDate, Multiplier } from '../../utils/helper';
import { decrypt, encrypt } from '../../utils/encodingdecoding';
import swal from 'sweetalert';
import Header from '../layout/Header';
import { useDispatch } from 'react-redux';

const ResellerCart = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const cardDetail =
		localStorage.getItem('card') &&
		JSON.parse(decrypt(localStorage.getItem('card')));
	const [loader, setLoader] = useState(false);
	const [state, setState] = useState({
		cart: [],
	});
	const { cart } = state;

	useEffect(() => {
		let result = [];
		const grouped = {};

		cardDetail?.forEach((obj) => {
			const code = obj.code;
			if (!grouped[code]) {
				grouped[code] = [];
			}
			grouped[code].push(obj);
		});

		for (const code in grouped) {
			result.push(grouped[code]);
		}

		let res = result.map((res) => {
			const code = res[0].code;
			const name = res[0].name;
			const image = res[0].image;
			const currencySymbol = res[0].currencySymbol;
			const quantity = res.reduce(
				(acc, obj) => acc + parseInt(obj.quantity),
				0,
			);
			const amount = res.reduce(
				(acc, obj) => acc + parseFloat(obj.discountedValue),
				0,
			);
			const savings = res.reduce(
				(acc, obj) => acc + parseFloat(obj.savings),
				0,
			);
			const total = res.reduce(
				(acc, obj) => acc + parseFloat(obj.total),
				0,
			);
			return {
				code,
				name,
				quantity,
				amount,
				savings,
				total,
				image,
				currencySymbol,
			};
		});
		setState((prev) => ({
			...prev,
			cart: res,
		}));
		localStorage.setItem('cartItem', res?.length);
	}, []);

	const getAmount = () => {
		let sum = 0;
		cart?.forEach((item) => {
			sum += parseFloat(item.total);
		});
		return sum;
	};

	const getSavings = () => {
		let sum = 0;
		cart?.forEach((item) => {
			sum += parseFloat(item.savings);
		});
		return sum.toFixed(2);
	};

	const amountPaid = () => {
		let sum = 0;
		cart?.forEach((item) => {
			sum += parseFloat(item.amount);
		});
		return Math.round(sum);
	};

	const generateCSV = (response) => {
		const data = [['Product Name', 'Card Number', 'PIN', 'Amount']];
		response.message.data.data.data.attributes.gift_card_orders.map(
			(order) => {
				order.attributes.vouchers.map((vou) => {
					const rowData = [
						vou.name,
						vou.card_number,
						vou.pin,
						vou.denomination,
					];
					data.push(rowData);
				});
			},
		);
		const csvContent =
			'data:text/csv;charset=utf-8,' +
			data.map((row) => row.join(',')).join('\n');
		const encodedUri = encodeURI(csvContent);
		const link = document.createElement('a');
		link.setAttribute('href', encodedUri);
		link.setAttribute('download', 'giftcard.csv');
		document.body.appendChild(link);
		link.click();
	};

	const generateCsv = (response) => {
		const data = [['Product Name', 'Card Number', 'PIN', 'Amount']];
		response[0]?.cards?.map((order) => {
			const rowData = [
				order.productName,
				order.cardNumber,
				order.cardPin,
				order.amount,
			];
			data.push(rowData);
		});
		const csvContent =
			'data:text/csv;charset=utf-8,' +
			data.map((row) => row.join(',')).join('\n');
		const encodedUri = encodeURI(csvContent);
		const link = document.createElement('a');
		link.setAttribute('href', encodedUri);
		link.setAttribute('download', 'giftcard.csv');
		document.body.appendChild(link);
		link.click();
	};

	const email = async (response) => {
		try {
			const tokenRes = await Token_Generator();
			let giftcards = [];

			if (response[0]?.vendor_name === 'QwikSilver') {
				// response[0]?.cards?.forEach((order) => {
				//     const temp = {
				//         productName: order.productName,
				//         cardNo: order.cardNumber,
				//         pin: order.cardPin,
				//         amount: order.amount,
				//     };
				//     giftcards.push(temp);
				//     generateCsv(response);
				// });
			} else {
				response.message.data.data.data.attributes.gift_card_orders.forEach(
					(order) => {
						order.attributes.vouchers.forEach((vou) => {
							const temp = {
								productName: order.name,
								cardNo: vou.card_number,
								pin: vou.pin,
								amount: vou.denomination,
							};
							giftcards.push(temp);
							generateCSV(response);
						});
					},
				);
			}

			const tableRows = giftcards
				.map(
					(card) => `
                <tr>
                    <td style='border: 1px solid black;border-collapse: collapse;padding:5px'>${
						card.productName || 'N/A'
					}</td>
                    <td style='border: 1px solid black;border-collapse: collapse;padding:5px'>${
						card.cardNo || 'N/A'
					}</td>
                    <td style='border: 1px solid black;border-collapse: collapse;padding:5px'>${
						card.pin || 'N/A'
					}</td>
                    <td style='border: 1px solid black;border-collapse: collapse;padding:5px'>${
						card.amount
					}</td>
                </tr>
            `,
				)
				.join('');

			const tempEmail = {
				subject: 'Purchased giftcard list',
				sendgridApiKey:
					'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',
				fromEmail: 'support@loyalty.novusloyalty.com',
				fromName: 'Novus Loyalty',
				emails: [
					{
						email: decrypt(localStorage.getItem('email')),
						name: decrypt(localStorage.getItem('name')),
					},
				],
				body: `<!DOCTYPE html>
                    <html lang="en">
                    <head>
                        <meta charset="UTF-8">
                        <meta name="viewport" content="width=device-width, initial-scale=1.0">
                        <title>Gift card list</title>
                    </head>
                    <body style="margin: 0;">
                        <p>Please find the purchased giftcard list below:</p>
                        <table width="580" border="0" cellspacing="0" cellpadding="0" align="center" bgcolor="#ffffff" style="margin: 0 auto; width: 580px; background: #fff;">
                            <thead>
                                <tr>
                                <th style='border: 1px solid black;padding:5px;border-collapse: collapse;'>Product Name</th>
                                    <th style='border: 1px solid black;padding:5px;border-collapse: collapse;'>Card No</th>
                                    <th style='border: 1px solid black;padding:5px;border-collapse: collapse;'>Pin</th>
                                    <th style='border: 1px solid black;padding:5px;border-collapse: collapse;'>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${tableRows}
                            </tbody>
                        </table>
                    </body>
                    </html>`,
				purpose: '',
				fileName: '',
			};

			const emailRes = await sendEmail(tokenRes.access_token, tempEmail);
			if (!emailRes.success) {
				throw new Error('Failed to send email');
			}
		} catch (error) {
			// Handle the error (e.g., show an alert to the user)
		}
	};

	const handleBuyNow = async () => {
		if (loader) return;
		setLoader(true);

		let redeemId = null; // FULL redeem ID
		let successRedeemId = null; // PARTIAL success redeem ID

		try {
			/* ----------------------------------
		   Storage & User
		----------------------------------- */
			const token = JSON.parse(localStorage.getItem('token_gen') || '{}');
			const user = JSON.parse(localStorage.getItem('profile') || {});
			const cart_code = decrypt(sessionStorage.getItem('cartCode') || '');
			const clientId = decrypt(localStorage.getItem('clientid') || '');
			const venDetails = JSON.parse(
				decrypt(sessionStorage.getItem('venDetails') || '{}'),
			);

			/* ----------------------------------
		   Item List
		----------------------------------- */
			const item_list = cardDetail.map((ele) => ({
				product_code: ele.code,
				item_type: 'Giftcard',
				quantity: Number(ele.quantity),
				price: Number(ele.fix_value),
				discount: Number(ele.discount),
				discounted_price: Number(ele.discountedValue),
				total: Number(ele.discountedValue) * Number(ele.quantity),
				vendor_code: ele.vendor_id,
			}));

			const totalAmount = cardDetail.reduce(
				(sum, ele) =>
					sum +
					Number(ele.discountedValue || 0) *
						Number(ele.quantity || 0),
				0,
			);

			const totalPoints = totalAmount * Multiplier;

			/* ----------------------------------
		   Giftcard Payload (Initial)
		----------------------------------- */
			let giftCardPayload = cardDetail.map((ele) => ({
				giftcard_id: ele.code,
				giftcardName: ele.name,
				price: Number(ele.fix_value),
				discountedvalue: Math.round(Number(ele.discountedValue)),
				discount: Number(ele.discount),
				saving: Number(ele.savings?.toFixed(2) || 0),
				quantity: Number(ele.quantity),
				Total: Number(ele.discountedValue) * Number(ele.quantity),
				createDatetime: getDate(new Date(), 'YYYY-MM-DD'),
				redeemTranID: '',
				category: ele.category,
				vendor_id: ele.vendor_id,
				imagePath: ele.image,
				status: 'failed',
			}));

			/* ----------------------------------
		    Redeem FULL Amount (Once)
		----------------------------------- */
			const walletRes = await redeemMerchantWallet(
				token.access_token,
				totalPoints,
				[],
			);

			if (walletRes?.message?.message !== 'Success') {
				throw new Error(walletRes?.message?.message);
			}

			redeemId = walletRes.message.data.redeemId;

			/* ----------------------------------
		    Save Order
		----------------------------------- */
			const orderId = await dispatch(
				saveOrder({
					cart_code,
					user_code: decrypt(user?.merchantcode),
					order_address: '',
					total_payment: totalAmount,
					total_points_redeemed: totalPoints,
					amount_paid: 0,
					item_list,
					payment_type: 'point',
					billing_address: venDetails?.address,
					shipping_address: venDetails?.address,
					client_id: clientId,
					delivery_charge: 0,
					order_review: false,
					manual_pay: false,
					order_type: 'giftcard',
				}),
			);

			if (!orderId) throw new Error('Order creation failed');

			/* ----------------------------------
		    Update Order (Vendor)
		----------------------------------- */
			const updateRes = await dispatch(
				updateOrder({
					id: orderId,
					payment_type: 'point',
					order_status: 10,
					payment_status: 0,
					novus_transaction_id: redeemId,
				}),
			);

			if (updateRes?.status_code !== 200) {
				throw new Error(updateRes?.message);
			}

			/* ----------------------------------
		    Failure Detection
		----------------------------------- */
			const failedItems =
				updateRes?.item_list?.filter(
					(i) =>
						i?.vendor_order_response?.error === true ||
						i?.status === 2,
				) || [];

			const failedAmount = failedItems.reduce(
				(sum, i) => sum + Number(i.amount || 0),
				0,
			);

			const successAmount = totalAmount - failedAmount;

			const isPartialFailure = failedAmount > 0 && successAmount > 0;
			const isFullFailure = failedAmount === totalAmount;

			/* ----------------------------------
		    Wallet Adjustment
		----------------------------------- */
			if (isPartialFailure || isFullFailure) {
				await refundMerchantWallet(
					token.access_token,
					encrypt(redeemId),
					{
						refund_points: totalPoints,
						reason: isPartialFailure
							? 'Partial vendor failure'
							: 'All items failed',
					},
				);
			}

			if (isPartialFailure) {
				const successRedeemRes = await redeemMerchantWallet(
					token.access_token,
					successAmount * Multiplier,
					[],
				);

				if (successRedeemRes?.message?.message !== 'Success') {
					throw new Error('Success amount redeem failed');
				}

				successRedeemId = successRedeemRes.message.data.redeemId;
			}

			/* ----------------------------------
		    Persist Giftcards (Correct IDs)
		----------------------------------- */
			giftCardPayload = giftCardPayload.map((ele) => {
				const failed = failedItems.some(
					(f) => f.product_code === ele.giftcard_id,
				);

				return {
					...ele,
					redeemTranID: failed
						? redeemId
						: successRedeemId || redeemId,
					refNo: updateRes?.code,
					status: failed ? 'failed' : 'success',
				};
			});

			await giftCardOrder(token.access_token, giftCardPayload);

			/* ----------------------------------
		    Refresh Wallet
		----------------------------------- */
			const merchantCode = decrypt(
				localStorage.getItem('merchantcode') || '',
			);

			const wallet = await getMerchantWallet(
				token.access_token,
				merchantCode,
			);

			if (wallet?.message === 'success') {
				const pointWallet = wallet.data.wallets.find(
					(w) => w.accounttype === 'Point',
				);
				if (pointWallet) {
					localStorage.setItem(
						'balance',
						encrypt(JSON.stringify(pointWallet.balance)),
					);
				}
			}

			/* ----------------------------------
		   SUCCESS
		----------------------------------- */
			localStorage.removeItem('card');
			localStorage.removeItem('cartItem');
			sessionStorage.removeItem('cartCode');
			swal({
				icon: 'success',
				title: 'Order placed successfully',
				timer: 4000,
				showConfirmButton: false,
			}).then(() => navigate('/reseller-orders'));
		} catch (err) {
			/* ----------------------------------
		   FULL FAILURE SAFETY
		----------------------------------- */
			try {
				const token = JSON.parse(
					localStorage.getItem('token_gen') || '{}',
				);

				if (redeemId) {
					await refundMerchantWallet(
						token.access_token,
						encrypt(redeemId),
						{ reason: 'Order failed' },
					);
				}
			} catch (_) {}

			swal({
				icon: 'error',
				title: err?.message || 'Something went wrong',
				timer: 4000,
				showConfirmButton: false,
			});
		} finally {
			setLoader(false);
		}
	};

	const safeParse = (key) => {
		try {
			const value = localStorage.getItem(key);
			return value ? JSON.parse(value) : null;
		} catch {
			return null;
		}
	};

	const handleDelete = async (ele) => {
		setLoader(true);

		try {
			/* ----------------------------------
		   Safe Profile Read
		----------------------------------- */
			const profile = safeParse('profile');

			if (!profile?.merchantcode) {
				throw new Error('User profile missing');
			}

			/* ----------------------------------
		    Remove item from backend
		----------------------------------- */
			const success = await dispatch(
				removeCartItem({
					product_code: ele.code,
					item_type: 'Giftcard',
				}),
			);

			if (!success) return;

			/* ----------------------------------
		    Fetch updated cart
		----------------------------------- */
			const cartData = await dispatch(
				getCartDetails({
					customerCode: profile.merchantcode,
				}),
			);

			/* ----------------------------------
		    Update UI from API
		----------------------------------- */
			const updatedCart =
				cartData?.products_list?.map((item) => ({
					code: item.product_code,
					name: item.name,
					quantity: item.quantity,
					amount: item.amount,
					savings:
						item.discount_percentage && item.discount_price
							? item.amount * item.quantity - item.discount_price
							: 0,
					total: item.discount_price,
					image: item.image,
					currencySymbol: '₹',
				})) || [];

			setState((prev) => ({
				...prev,
				cart: updatedCart,
			}));
		} catch (err) {
			console.error('Delete cart item failed:', err);
		} finally {
			setLoader(false);
		}
	};

	return (
		<>
			{loader && (
				<div className='mainPreloaderMain'>
					<div className='mainPreloader'>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			)}
			<div className='reseller_home'>
				<Header name='Cart Details' />
				<div className='reseller_home__body'>
					<div className='reseller_home_cart_box'>
						<div className='cart_box_left'>
							{cart?.length ? (
								cart?.map((ele, i) => (
									<div
										className='cart_card_details'
										key={i}>
										<div className='cart_card_details_boxed'>
											<div className='cart_card_details_boxed_i'>
												<div className='cart_card_details_boxed_i_i'>
													<img
														src={ele.image}
														alt={ele.name}
													/>
												</div>
												<div className='cart_card_details_boxed_i_c'>
													<h5>{ele.name}</h5>
												</div>
											</div>
											<div className='cart_card_details_boxed_c'>
												<div className='cart_card_details_c_c'>
													<h5>Quantity</h5>
													<span>{ele.quantity}</span>
												</div>
												<div className='cart_card_details_c_c'>
													<h5>Amount</h5>
													<span>
														{ele.currencySymbol}{' '}
														{ele.amount.toFixed(2)}
													</span>
												</div>
												<div className='cart_card_details_c_c'>
													<h5 className='discounted'>
														Savings
													</h5>
													<span className='discounted'>
														{ele.currencySymbol}{' '}
														{ele.savings.toFixed(2)}
													</span>
												</div>
												<div className='cart_card_details_c_c'>
													<Link
														title='Edit'
														to='/reseller-details'
														state={{
															for: 'edit',
															code: ele.code,
															currencySymbol:
																ele.currencySymbol,
														}}>
														<img
															src={edit_card}
															alt='edit cart'
														/>
													</Link>
												</div>
												<div className='cart_card_details_c_c'>
													<Link
														title='Delete'
														onClick={() =>
															handleDelete(ele)
														}>
														<img
															src={delete_card}
															alt='delete cart'
														/>
													</Link>
												</div>
											</div>
										</div>
									</div>
								))
							) : (
								<div className='no_items_box'>
									<div className='no_items_boxed'>
										<img
											src={no_items}
											alt='cart'
										/>
										<h4>No items in the Cart</h4>
										<Link to='/reseller-home'>
											Buy Giftcards
										</Link>
									</div>
								</div>
							)}
						</div>
						<div className='cart_box_right'>
							<div className='cart_box_right_row'>
								<div className='voucher_details'>
									<p>Total Gift Cards</p>
									<h4>{cart?.length}</h4>
								</div>
								<div className='voucher_details'>
									<p>Amount</p>
									<h4>
										{cart[0]?.currencySymbol} {getAmount()}
									</h4>
								</div>
								<div className='voucher_details discounted'>
									<p>Savings</p>
									<h4>
										{cart[0]?.currencySymbol} {getSavings()}
									</h4>
								</div>
								<div className='voucher_details'>
									<p>Total Amount</p>
									<h4>
										{cart[0]?.currencySymbol} {amountPaid()}
									</h4>
								</div>
								<div className='voucher_details'>
									<p>Total Points</p>
									<h4>
										{Number(amountPaid() ?? 0) * Multiplier}
									</h4>
								</div>
								<div className='voucher_details'>
									<button
										type='button'
										onClick={handleBuyNow}
										disabled={cart?.length <= 0}>
										Buy Now
									</button>
								</div>
							</div>
						</div>
					</div>

					{/* <div className="reseller_popup_box">
                        <div className="reseller_popup_boxed">
                            <button type="button" className="close_it">
                                X
                            </button>
                            <div className="reseller_popup_boxed_inner">
                                <img src={alert} />
                                <h5>Your points balance is not sufficient to complete this transaction.</h5>
                            </div>
                        </div>
                    </div> */}
				</div>
			</div>
		</>
	);
};

export default ResellerCart;
